import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

import { featureQueryOptions } from '@/queries/useFeaturesQuery';
import type { ServiceStationFeature } from '@/types/ServiceStationFeature';

export const serviceStationQueryOptions = ({ serviceStationId }: { serviceStationId: string }) =>
  featureQueryOptions<ServiceStationFeature>({
    collection: 'service_station_view',
    query: { filter: `id = '${serviceStationId}'` },
  });

export const useServiceStationQuery = (id?: number) => {
  const params = useParams({ strict: false });
  const serviceStationId = id?.toString() ?? params.serviceStationId;

  return useQuery({
    ...serviceStationQueryOptions({ serviceStationId: serviceStationId ?? '' }),
    placeholderData: keepPreviousData,
    enabled: !!serviceStationId,
  });
};
